import { Flex, Text, Button } from "@radix-ui/themes";
import React from "react";

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <Flex justify="between" align="center" style={styles.flexContainer}>
        {/* Left Section */}
        <Flex align="center" gap="5">
          <Text
            size="5"
            style={{
              fontFamily: "'Bungee Hairline', sans-serif",
              fontWeight: 600,
              fontStyle: "normal",
              cursor: "pointer",
            }}
          >
            Tellos AI
          </Text>
          {/* <Link href="#pricing" variant="ghost" style={{ color: "white" }}>
            Terms of Service
          </Link>
          <Link href="#about" variant="ghost" style={{ color: "white" }}>
            Privacy Policy
          </Link>
          <Link href="#about" variant="ghost" style={{ color: "white" }}>
            Refund Policy
          </Link> */}
        </Flex>

        {/* Right Section */}
        <Flex align="center" gap="5">
          <Button variant="ghost" color="green">
            smartaipodcast@gmail.com
          </Button>
          {/* <Link
            href="https://linkedin.com"
            variant="ghost"
            style={{ color: "white" }}
          >
            LinkedIn
          </Link> */}
        </Flex>
      </Flex>

      <div style={styles.copyRight}>
        <Text size="1">© 2025 Tellos AI. All rights reserved.</Text>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: "black",
    color: "white",
    padding: "20px 10px",
    fontSize: "14px",
  },
  flexContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    flexWrap: "wrap",
  },
  copyRight: {
    textAlign: "center",
    marginTop: "10px",
    color: "#a1a1a1",
  },
};

export default Footer;